export default __webpack_public_path__ + "static/media/picto_Dev.ce55a6fa.svg";